import Icons from 'components/Icons';
import GoogleMapReact from 'google-map-react';
import { Config } from 'utils';
import './location.scss'
import { useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';

const Location = () => {
    const { public: { listing, loading } } = useSelector((state) => state.listing);
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
    const [mapKey, setMapKey] = useState(0);

    const fetchGeocode = useCallback(async () => {
        const address = `${listing.address}, ${listing.city}, ${listing.state}, ${listing.zip_code}, ${listing.country}`;
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${Config.GOOGLE_MAP_KEY}`);
        const result = await response.json();
        return result.results[0].geometry.location;
    }, [listing]);

    const getLat = async () => {
        const coordinates = await fetchGeocode();
        return coordinates.lat;
    }

    const getLng = async () => {
        const coordinates = await fetchGeocode();
        return coordinates.lng;
    }

    useEffect(() => {
        const getCoordinates = async () => {
            const lat = listing.lat || await getLat();
            const lng = listing.lng || await getLng();
            setCoordinates({ lat, lng });
            setMapKey(prevKey => prevKey + 1);
        };

        if (!loading) {
            getCoordinates();
        }
    }, [listing, loading]);

    const Marker = () => <Icons.Marker />;
    
    return (

        <div className='map-location-container'>
            {
                !loading && coordinates.lat && coordinates.lng &&
                <div className='map'>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: Config.GOOGLE_MAP_KEY }}
                        defaultCenter={{ lat: listing.lat || coordinates.lat, lng: listing.lng || coordinates.lng }}
                        defaultZoom={17}
                        mapId={'e29130846f876b2c'}
                        key={mapKey}
                    >
                        <Marker
                            lat={listing.lat || coordinates.lat}
                            lng={listing.lng || coordinates.lng}
                        />
                    </GoogleMapReact>
                </div>
            }
        </div>
    )
}


export default Location;